import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import sharedConfigReducers from '../../config/reducers';
import publicSessionReducers from '../../publicSession/reducers';
import watchButtonReducers from '../../WatchButton/redux/reducers';
import commentEditorReducers from '../../CommentEditor/redux/reducers';
import mediaPopupReducers from '../../MediaPopup/reducers';
import modalReducers from '../../Modals/redux/reducer';
import popoversReducers from '../../Popovers/redux/reducer';
import notificationReducers from '../../Notifications/redux/reducer';
import MentionReducers from '../../DaEditorWrapper/AsyncHandlers/Mentions/reducers';
import editorsReducer from '../../DaEditorWrapper/redux/reducers';
import emoteSelectorReducers from '../../EmoteSelector/redux/reducers';
import writerReducers from '../../WriterPopup/redux/reducers';
import statusEditPopupReducers from '../../StatusEditPopup/reducers';
import pollEditPopupReducers from '../../PollEditPopup/redux/reducer';
import userAvatarReducers from '../../User/AvatarPopover/reducers';
import streamReducers from '../../Stream/reducers';
import { entitiesReducers } from '../entities';
import collectionPanelReducers from '../../CollectionPanel/redux/reducer';
import measuredCookieReducers from '../../Measured/redux/reducer';
import siteHeaderReducer from '../../SiteHeader/redux/reducer';
import flagsReducers from '../flags/reducer';
import firstTimeFlagsReducers from '../firstTimeFlags/reducers';
import duperbrowseReducers from '../../Duperbrowse/redux/reducer';
import deviationBackgroundReducer from '../../DeviationBackground/redux/reducer';
import moderationReducer from '../../Moderation/redux/reducer';
import deviationPageReducer from '../../DeviationPage/redux/reducer';
import addToGroupReducer from '../../AddToGroupsPanel/redux/reducer';
import artBrandedPopupReducer from '../../ArtBrandedPopup/redux/reducers';
import biReducer from '../../biLogger/redux/reducer';
import coreBadgeReducer from '../../coreBadge/redux/reducer';
import networkbarReducer from '../../NetworkBar/redux/reducer';
import simpleXHRReducer from '../../simpleXHR/reducer';
import uploadsReducers from '../uploads/reducers';
import tagInputReducer from '../../TagInput/redux/reducer';
import reportPageReducer from '../../ReportPage/redux/reducers';
import deviationSubmitPopupReducer from '../../DeviationSubmitPopup/redux/reducer';
import earningsDisplayReducer from '../../EarningsDisplay/redux/reducers';
import adsReducer from '../../Ads/redux/reducer';
export const reducers = _object_spread({}, sharedConfigReducers, publicSessionReducers, watchButtonReducers, streamReducers, entitiesReducers, commentEditorReducers, mediaPopupReducers, modalReducers, popoversReducers, notificationReducers, editorsReducer, MentionReducers, emoteSelectorReducers, writerReducers, statusEditPopupReducers, pollEditPopupReducers, userAvatarReducers, collectionPanelReducers, flagsReducers, firstTimeFlagsReducers, siteHeaderReducer, measuredCookieReducers, duperbrowseReducers, deviationBackgroundReducer, moderationReducer, deviationPageReducer, addToGroupReducer, artBrandedPopupReducer, biReducer, coreBadgeReducer, networkbarReducer, simpleXHRReducer, uploadsReducers, tagInputReducer, reportPageReducer, deviationSubmitPopupReducer, earningsDisplayReducer, adsReducer);
